module.exports = __webpack_public_path__ + "img/close.c1d876b9.png";